import z, { ZodType } from 'zod';
import { Player, playerSchema } from './player';

export type PlayersResponse = {
	deviceId: number;
	players: Player[];
};

export const playersResponseSchema: ZodType<PlayersResponse> = z.object({
	deviceId: z.number(),
	players: z.array(playerSchema),
});
